import { QuestionPreviewNext } from "@vericus/cadmus-common";
import { GridIcon } from "@vericus/cadmus-icons";
import { Button, Text } from "@vericus/cadmus-ui";

import { useMarkerRubricOpenInModal } from "@/features/rubric";
import { AnswerBlockFragment, SocraticTurnFragment } from "@/generated/graphql";
import { formatMilliseconds } from "@/utils/datetime";

import * as styles from "./dialogue-panel.css";

interface Props {
  answerBlock: AnswerBlockFragment;
  turn: SocraticTurnFragment;
  responseTimeSeconds: number;
}

export function DialoguePanel(props: Props) {
  const { answerBlock, turn, responseTimeSeconds } = props;

  const points = answerBlock.points;
  const orderLabel = answerBlock.orderLabel ?? "1";

  const openMarkerRubric = useMarkerRubricOpenInModal({
    questionId: answerBlock.question?.id,
  });

  return (
    <div className={styles.root}>
      <QuestionPreviewNext
        mode="question"
        questionId={answerBlock.question?.id ?? "1"}
        promptDoc={turn.questionPrompt}
        data={{
          question_type: "video",
          max_score: points ?? 0,
          fields: null,
          answer: null,
          references_answer: null,
          field_outcomes: [],
          question_outcome: null,
        }}
        questionTitle={`Question ${orderLabel ?? "1"}`}
      />
      <div className={styles.tip}>
        <Text kind="bodyMd">
          You have {formatMilliseconds(responseTimeSeconds * 1000)} to respond
        </Text>
      </div>
      {openMarkerRubric != null && (
        <Button
          onClick={openMarkerRubric}
          icon={<GridIcon label="" size={24} />}
          className={styles.rubricButton}
        >
          View Rubric
        </Button>
      )}
    </div>
  );
}
